<template>
    <div class="column-layout">
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>成套单品管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="org-tree-layout">
            <swb-popover-org-tree :showMgmt="true" :showIncludeSubComs="true" :initIncludeSubComs="initIncludeSubComs" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <swb-query-sort-area name="query-sort-block" :confKey="confKey" :configAuto="configAuto" :queryOnLoad="queryOnLoad" :custConfEnabled="custConfEnabled" :onConfigReady="onConfigReady" ref="query_model_ctrl" :queryHandler="queryHandler"></swb-query-sort-area>
        <div name="btn-bar" class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="saveSuit()">
                    <span>新增套装</span>
                </button>
            </div>
            <div class="right">
                <div class="swb-btn swb-btn-small swb-btn-primary" @click="doExport">导出贴码</div>
            </div>
        </div>
        <swb-result-table name="result_table" :confKey="confKey" :configAuto="configAuto" :custConfEnabled="custConfEnabled" ref="result_table" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'

    import appConf from '../../app.conf';
    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm, getDevcGroupNameByCatId } from '../index'
    import { setAssetsGroupDevcFilter } from '../asset/selectDlg'
    import { openBigImgDlg } from '../comn/dialog'
    import { loadRetailerDevcGroupCascList, loadRetailerShopTagList } from '../retailer/asset-comn'
    import { getMerchantBizParam } from '../asset/assetMain'

    import devcApi from '../../api/devc'
    import userApi from '../../api/user';
    import retailerApi from '../../api/retailer'

    import SwbShopDeviceSuitSave from './ShopDeviceSuitSave';
    Routes.add(SwbShopDeviceSuitSave);
    import SwbShopDeviceSuitDetail from './ShopDeviceSuitDetail';
    Vue.regist(SwbShopDeviceSuitDetail);
    import SwbShopDeviceList from '../devc/ShopDeviceList';
    Vue.regist(SwbShopDeviceList);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    let searchConfigData = {};

    export default {
        name: 'swb-shop-device-suit-list',
        path: '/shop/device/suit/list',
        desc: '资产套装列表',
        data: function () {
            return {
                confKey: "swb-shop-device-suit-list",
                configAuto: true,
                queryOnLoad: true,
                custConfEnabled: true,
                // 分页信息
                theTableHeight: '300',
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 150,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                // 其他信息
                dataList: [],
                treeCollapse: true,
                thisComId: null,
                includeSubComs: false,
                exportParmas: null,
                multipleSelection: [],
                initIncludeSubComs: false,
                suitId: null,
                scopeEntity: null,
                mgmtSmlAreaId: null,
                suiteMgmtEnabled: false
            }
        },
        created: function () {
            let self = this;
            //
            this.suitId = this.$route.query.suitId || null;
            this.thisComId = this.$route.query.comId || null;
            let includeSubComs = Utils.isTrue(this.$route.query.includeSubComs) || false;
            if(Utils.isTrue(includeSubComs)) {
                this.initIncludeSubComs = includeSubComs;
                this.includeSubComs = includeSubComs;
            }
            this.getCurrUserInfo();
            //
            getMerchantBizParam("device.or.asset.suite.mgmt.enabled", function (result) {
                self.suiteMgmtEnabled = Utils.isTrue(result);
            });
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.breadcrumb-layout, .org-tree-layout, [name="query-sort-block"], [name="btn-bar"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onConfigReady() {
                this.initAsyncQueryModel();
            },
            initAsyncQueryModel() {
                let self = this;
                // 门店标签
                loadRetailerShopTagList(function (dataList) {
                    self.updateQueryModelField("retailerShopTagId", dataList);
                });
                // 分类分组
                loadRetailerDevcGroupCascList(function (dataList) {
                    self.updateQueryModelField("devcGroupId", dataList);
                });
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'imageUrl': function (row, colName, colValue, rowIndex, colConf) {
                        if(Utils.isNoB(row.imageUrl)) {
                            return;
                        } else {
                            return '<a><img style="height: 36px;width: 36px" src="' + row.imageUrl + '"/></a>';
                        }
                    },

                    'devcTmpNo': function (row, colName, colValue, rowIndex, colConf) {
                        return '<a name="showTmp" class="table-cell-link">' + row.devcTmpNo + '</a>';
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let domHtml = '';
                        if(self.checkActionPerm('view')) {
                            domHtml = domHtml + '<a name="view" class="swb-btn swb-btn-link">查看</a>';
                        }
                        if(self.checkActionPerm('modify')) {
                            domHtml = domHtml + '<a name="modify" class="swb-btn swb-btn-link">维护</a>';
                        }
                        if(self.checkActionPerm('delete')) {
                            domHtml = domHtml + '<a name="delete" class="swb-btn swb-btn-link">解散</a>';
                        }
                        return domHtml;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'imageUrl': function (row, colName, colValue, rowIndex, btnName) {
                        self.viewImage(colValue);
                    },
                    'devcTmpNo': function (row, colName, colValue, rowIndex, btnName) {
                        self.toShopDeviceList(row.devcTmpNo);
                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'view') {
                            self.viewDetail(row.id);
                        } else if(btnName == 'modify') {
                            self.updateSuit(row.id);
                        } else if(btnName == 'delete') {
                            self.deleteSuit(row.id);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getDevcGroupNameByCatId(catId){
                return getDevcGroupNameByCatId(catId);
            },
            getCurrUserInfo(){
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == 'info') {
                        let scopeEntity = result.data.scopeEntity;
                        //
                        self.thisComId = scopeEntity.bizUnitId;
                        self.scopeEntity = scopeEntity;
                    }
                });
            },
            checkActionPerm: function (action) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, null);
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDataList();
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDataList();
            },
            getDataList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.retailerShopId = self.thisComId;
                filterItems.includeSubComs = self.includeSubComs;
                filterItems.mgmtSmlAreaId = self.mgmtSmlAreaId;
                if(!Utils.isNoB(self.suitId)) {
                    filterItems.id = self.suitId;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                self.exportParmas = filterItems;
                //
                let theLoading = MsgBox.loading();
                devcApi.getShopDeviceSuitPaginatedList(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        let dataList = result.data.rows;
                        let pagination = result.data.pagination;
                        self.renderTable(dataList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            showTreeCollapse: function (treeCollapse) {
                this.treeCollapse = treeCollapse;
            },
            checkComCatChange: function (eventData) {
                if(eventData.id != this.thisComId || this.includeSubComs != eventData.includeSubComs) {
                    this.mgmtSmlAreaId = null;
                    if(Utils.isTrue(eventData.mgmtFlag)) {
                        let scopeEntity = this.scopeEntity;
                        this.thisComId = scopeEntity.comId;
                        this.includeSubComs = true;
                        this.mgmtSmlAreaId = eventData.id;
                    } else {
                        this.thisComId = eventData.id;
                        this.includeSubComs = eventData.includeSubComs;
                    }
                    this.getDataList();
                }
            },
            // 查看详情
            viewDetail(id){
                let self = this;
                Vue.$showDialog({
                    title: "资产套装详情",
                    width: 1300,
                    height: 800,
                    okVisible: false,
                    showCloseBtn: true,
                    cancelText: '关闭',
                    template: '<div>' +
                    '<swb-shop-device-suit-detail :id="id" :toShopDeviceList="toShopDeviceList"></swb-shop-device-suit-detail>' +
                    '</div>',
                    data: {
                        id: id
                    },
                    methods: {
                        toShopDeviceList: function (no) {
                            self.toShopDeviceList(no);
                        },
                    },
                });
            },
            toShopDeviceList(no) {
                let data = {
                    tmpNo: no
                };
                let hashUrl = Utils.makeUrl(SwbShopDeviceList.path, data);
                appConf.openPageRouteUrl(null, "/bench/home", hashUrl);
            },
            saveSuit(){
                if(this.suiteMgmtEnabled == true) {
                    this.$router.push({
                        path: SwbShopDeviceSuitSave.path
                    });
                } else {
                    MsgBox.warning("请在设置参数中开启资产/设备套装管理！");
                }
            },
            // 修改
            updateSuit(id){
                if(this.suiteMgmtEnabled == true) {
                    this.$router.push({
                        path: SwbShopDeviceSuitSave.path,
                        query: {id: id}
                    });
                } else {
                    MsgBox.warning("请在设置参数中开启资产/设备套装管理！");
                }
            },
            // 删除
            deleteSuit(id){
                if(this.suiteMgmtEnabled != true) {
                    MsgBox.warning("请在设置参数中开启资产/设备套装管理！");
                    return;
                }
                let self = this;
                //弹出确认框
                this.$confirm('确定要解散此套装吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoading = MsgBox.loading();
                    devcApi.deleteShopDeviceSuit(id, function (result) {
                        theLoading.close();
                        if(result.type === "info") {
                            MsgBox.success("操作成功");
                            self.getDataList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            doExport(){
                let self = this;
                //
                let multipleSelection = this.getTableSelection();
                if(multipleSelection.length == 0) {
                    //
                    let postData = self.exportParmas;
                    devcApi.saveSuitParamsForExport(postData, function (result) {
                        if(result.type == 'info') {
                            self.showTheExportDlg(null, result.data);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    let postData = [];
                    multipleSelection.forEach(function (el) {
                        postData.push({
                            name: el.name,
                            no: el.no,
                            devcCatName: el.devcCatName,
                            devcBrandName: el.devcBrandName
                        });
                    });
                    //
                    devcApi.saveSuitModelForExport(postData, function (result) {
                        if(result.type == 'info') {
                            self.showTheExportDlg(result.data);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            },
            showTheExportDlg(dataUuid = null, paramsUuid = null) {
                let theDlg = Vue.$showDialog({
                    title: '确定资产贴码文件格式 - 导出' + (dataUuid ? '选中的资产' : ''),
                    showCloseBtn: true,
                    width: 800,
                    height: 600,
                    template: '<div>' +
                    '<div class="hint block" v-if="isShowMessage">' +
                    '   <p>{{message}}</p>' +
                    '</div>' +
                    '<div class="simple-form">' +
                    '   <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label >分组方式</label>' +
                    '        </div>' +
                    '        <div class="form-value">' +
                    '            <el-radio-group v-model="group">' +
                    '                <el-radio v-for="dataItem in groupTypes" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                    '            </el-radio-group>' +
                    '        </div>' +
                    '    </div>' +
                    '   <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label >模版类型</label>' +
                    '        </div>' +
                    '        <div class="form-value">' +
                    '            <el-radio-group v-model="modelType" @change="modelTypeChange">' +
                    '                <el-radio v-for="dataItem in allModelTypes" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                    '            </el-radio-group>' +
                    '        </div>' +
                    '    </div>' +
                    '   <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label >模版尺寸</label>' +
                    '        </div>' +
                    '        <div class="form-value radio">' +
                    '            <el-radio-group v-model="size">' +
                    '                <el-radio class="mr5 mb5" v-for="dataItem in allSizes" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                    '            </el-radio-group>' +
                    '        </div>' +
                    '    </div>' +
                    '   <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label >纸张尺寸</label>' +
                    '        </div>' +
                    '        <div class="form-value">' +
                    '            <el-radio-group v-model="paper">' +
                    '                <el-radio v-for="dataItem in allPaper" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                    '            </el-radio-group>' +
                    '        </div>' +
                    '    </div>' +
                    '    <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label >文件格式</label>' +
                    '        </div>' +
                    '        <div class="form-value">' +
                    '            <el-radio-group v-model="format">' +
                    '                <el-radio v-for="dataItem in allFormats" key="value"  :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                    '            </el-radio-group>' +
                    '        </div>' +
                    '    </div>' +
                    '    <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label >文件名称</label>' +
                    '        </div>' +
                    '        <div class="form-value">' +
                    '           <el-input v-model="fileName" title="导出文件名称，可选填，默认为 【所属机构名称】-资产服务号（注意：不要带文件扩展名）" clearable style="color:navy;width: 300px;"></el-input>' +
                    '        </div>' +
                    '    </div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        groupTypes: [{value: 'cat', text: '分类'}, {value: 'cat brand', text: '分类 + 品牌'}],
                        allModelTypes: [{value: 'standard', text: '标准码'}, {value: 'nonstandard', text: '非标准码'}],
                        allFormats: [{value: 'pdf', text: 'pdf'}, {value: 'docx', text: 'docx'}],
                        allSizes: [],
                        standardSizes: [
                            {value: 'small', text: '小标签(24mm*24mm)'},
                            {value: 'middle', text: '中标签(36mm*36mm)'},
                            {value: 'shoppingCart', text: '购物车标签1(16mm*16mm)'},
                            {value: 'squareLarge', text: '方形大标签(90mm*90mm)'}
                        ],
                        nonstandardSizes: [
                            {value: 'small', text: '小标签(24mm*60mm)'},
                            {value: 'middle', text: '中标签(36mm*80mm)'},
                            {value: 'shoppingCart', text: '购物车标签1(16mm*16mm)'},
                            {value: 'squareSmall', text: '方形小标签(24mm*24mm)'},
                            {value: 'squareLarge', text: '方形大标签(90mm*90mm)'}
                        ],
                        allPaper: [{value: 'A4', text: 'A4'}, {value: '100mm', text: '100mm'}],
                        group: 'cat',
                        format: 'pdf',
                        modelType: 'standard',
                        size: 'small',
                        paper: 'A4',
                        fileName: '',
                        message: '注意: 请在1分钟内完成导出操作（防止数据过期）',
                        isShowMessage: false
                    },
                    methods: {
                        modelTypeChange(){
                            if(this.modelType == 'standard') {
                                this.allSizes = this.standardSizes;
                            } else {
                                this.allSizes = this.nonstandardSizes;
                            }
                            this.size = this.allSizes[0].value;
                        }
                    },
                    okClicked: function () {
                        let theDownloadUrl = Utils.makeUrl(getAppUrl('/shop/devc/suit/stick/qrcode/file/jsp'), {
                            group: this.group,
                            format: this.format,
                            modelType: this.modelType,
                            size: this.size,
                            paper: this.paper,
                            fileName: this.fileName,
                            dataUuid: dataUuid || null,
                            paramsUuid: paramsUuid || null
                        });
                        Utils.setPageUrl(theDownloadUrl, '_blank');
                        //
                        return true;
                    },

                    lifecycle: {
                        created: function () {
                            this.isShowMessage = true;
                            this.allSizes = this.standardSizes;
                        }
                    }
                });
            },
            viewImage: function (fileBrowseUrl) {
                openBigImgDlg(fileBrowseUrl);
            },
        }
    }
</script>
<style>
    .form-value.radio .el-radio + .el-radio {
        margin-left: 0;
    }

    .form-value.radio {
        width: calc(100% - 126px - 20px);
        width: -webkit-calc(100% - 126px - 20px);
        width: -moz-calc(100% - 126px - 20px);
    }
</style>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceSuitList.vue